module.exports = __webpack_public_path__ + "static/img/researchInstitutes1.3e85a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/researchInstitutes1.png
// module id = O2E4
// module chunks = 1